module.exports = __webpack_public_path__ + "static/img/6.4be6dbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news14/6.png
// module id = /c3H
// module chunks = 1